var html = document.querySelector('html');
var header = document.querySelector('.header');
var area = document.querySelector('.header-push');
var Observer = new IntersectionObserver(function (entries) {
  html.classList.toggle('scrolled', !entries[0].isIntersecting);
});
Observer.observe(area);